import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Language",
  "description": "",
  "published": "2013-07-25T00:00:00.000Z",
  "redirect_from": ["/blog/language/swizec/6293"],
  "categories": "Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`After my third cup of tea in twenty minutes I was still wasted. Emacs staring me down, terminal blaring with test failures, social networks bleeping and blapping for attention, coworkers daring to make sounds. Music was annoying.`}</p>
    <p><em parentName="p">{`"for starters just make a collection and write some tests"`}</em>{`, I wrote down in my notebook. I stared at the words for five minutes.`}</p>
    <p>{`I knew what I wanted to do. I knew how to do it. I couldn't do it. I just sat there, staring at those 10 words.`}</p>
    <p><em parentName="p">{`"Lollobrigida"`}</em>{`, a tiny voice in the back of my mind whispered.`}</p>
    <p>{`So I put them on.`}</p>
    <p>{`I fell in love with Lollobrigida at last year's EXIT festival. The energetic stage performance, sexy vocals and funny lyrics in a language I only used to know from jokes won me over.`}</p>
    <p>{`In the next few hours I banged out two new features from scratch. Alone in my world with only Emacs and Lollobrigida for company the world could be crumbling around me and I wouldn't notice.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/7sfFwonuTcC5KdBhmcBP",
        "alt": null
      }}></img></p>
    <p>{`Lollobrigida wasn't English. That's all it took. Something not-English blasting in my ears.`}</p>
    <p>{`I'm not one to shy away from using English, after all I've been writing this blog in English for years, the books I'm writing are English, most of my Twitter posts are English, even the online forum I've been a part of for 8 years is English.`}</p>
    <p>{`Hell, anyone who knows me will tell you the language I usually speak is a mix between English and Slovenian. When I can't think of a word in one language I'll simply use the other. I often begin my sentences in Slovenian and switch to English half-way through because it flows better or expresses a concept better.`}</p>
    <p>{`A favourite drinking game in my group of friends is banning English from the conversation. It's pretty brutal.`}</p>
    <p>{`But here in the US I can't do that. These four weeks mark the longest streak I've ever had of using only one language. There's simply nobody around who speaks Slovenian.`}</p>
    <p>{`It's tiring.`}</p>
    <p>{`When I talk and a word doesn't immediately come to mind, I can't just switch to a different language, I have to stop and think until a synonym comes to mind or somebody helps me out. I always have to be vigilant about what I'm saying because when I'm tired and we're just hanging out, I often almost say something Slovenian, bite my tongue midway through and say it in English.`}</p>
    <p>{`I don't think anyone's noticed though. If they have, they haven't mentioned it.`}</p>
    <p>{`But Lollobrigida relaxed my brain, even though it's in Croatian - a language I was convinced I didn't know until last year I suddenly realised it's actually rather understandable. The trips to Serbia and then Croatia and Bosnia and in winter again Bosnia and then Serbia confirmed that, yup, I understand the language. Can almost speak it now.`}</p>
    <p>{`No idea where or how I learned, but it seems to relax my brain just because it's much more similar to Slovenian than English, even though English is far more familiar.`}</p>
    <p>{`Strange.`}</p>
    <p>{`Considering how second nature English is to me and how much I use it every day, I would never have thought using it exclusively could be a problem. But there you go. The problems almost-bilinguals face ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      